import { Helmet } from "react-helmet-async";
import { BUSINESS, SITE_URL } from "@/data/business";

export const SEO = ({ title, description, path = "/", schema }) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="business.business" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={BUSINESS.name} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "HealthAndBeautyBusiness",
  name: BUSINESS.name,
  image: `${SITE_URL}/favicon.svg`,
  telephone: BUSINESS.phoneClean,
  address: {
    "@type": "PostalAddress",
    streetAddress: BUSINESS.address,
    addressLocality: "Hyderabad",
    addressRegion: "Telangana",
    postalCode: "500016",
    addressCountry: "IN",
  },
  url: `${SITE_URL}/`,
});
